module.exports = __webpack_public_path__ + "img/icon3.8e51de4d.png";